"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _uuid = require('shared/services/uuid');
var _time = require('shared/services/time');


/* The patient page's thread, as the provider redesign draws it: day pills,
 * and runs of one sender's messages within 30 minutes, the first carrying
 * the sender's name and time. The provider's processMessages reads
 * staff-only fields, so this adapter reads the patient message rows. */

const RUN_WINDOW_MS = 30 * 60 * 1000














































const isSet = (key) => !!key && key !== _uuid.EMPTY_BLUID

// The team's automatic reply: from the clinic, with no person behind it.
 const isAutoReply = (row) => row.Type === 'auto_reply'; exports.isAutoReply = isAutoReply
const AUTO_REPLY_NAME = 'Auto-reply'

const senderOf = (row) => {
  if (exports.isAutoReply.call(void 0, row)) return 'auto-reply'
  return isSet(row.FromPatientKey) ? `patient:${row.FromPatientKey}` : `user:${row.FromUserKey}`
}

// The text the server puts in a recalled message, for patients as for staff.
const RECALLED_TEXT = '<This message was recalled>'

 const isRecalled = (row) => row.Type !== 'meta' && row.TextContent === RECALLED_TEXT; exports.isRecalled = isRecalled

// A sent file's name; an upload in progress has none yet.
 const fileNameOf = (row) => {
  const metadata = _optionalChain([row, 'access', _ => _.FileInfo, 'optionalAccess', _2 => _2.Metadata])
  return metadata && 'FileName' in metadata ? metadata.FileName : undefined
}; exports.fileNameOf = fileNameOf

// What a message says, for its quote, its sheet and Reply.
 const summaryOf = (row) => row.TextContent || exports.fileNameOf.call(void 0, row) || 'File'; exports.summaryOf = summaryOf

const nameOf = (people, userKey, patientKey) => {
  if (isSet(patientKey)) {
    return patientKey === people.currentPatientKey ? 'You' : _nullishCoalesce(_optionalChain([people, 'access', _3 => _3.patients, 'access', _4 => _4[patientKey], 'optionalAccess', _5 => _5.Name]), () => ( ''))
  }
  return isSet(userKey) ? _nullishCoalesce(_optionalChain([people, 'access', _6 => _6.users, 'access', _7 => _7[userKey], 'optionalAccess', _8 => _8.Name]), () => ( '')) : ''
}

/* From the server's preview, or, for a reply still being sent, from the
 * quoted message when the page has it. */
const quoteOf = (row, people, byKey) => {
  const targetKey = row.ReplyToMessageKey
  if (!targetKey) return undefined
  const preview = row.ReplyPreview
  if (_optionalChain([preview, 'optionalAccess', _9 => _9.Recalled])) return { targetKey, name: '', text: 'Message recalled', muted: true }
  if (_optionalChain([preview, 'optionalAccess', _10 => _10.Unavailable])) return { targetKey, name: '', text: 'Message unavailable', muted: true }
  if (preview) {
    return {
      targetKey,
      name: nameOf(people, preview.FromUserKey, preview.FromPatientKey),
      text: preview.MessageType === 'file' ? _nullishCoalesce(preview.FileName, () => ( 'File')) : _nullishCoalesce(preview.Snippet, () => ( '')),
      muted: false,
    }
  }
  const target = byKey.get(targetKey)
  if (!target) return { targetKey, name: '', text: 'Message unavailable', muted: true }
  if (exports.isRecalled.call(void 0, target)) return { targetKey, name: '', text: 'Message recalled', muted: true }
  return {
    targetKey,
    name: nameOf(people, target.FromUserKey, target.FromPatientKey),
    text: exports.summaryOf.call(void 0, target),
    muted: false,
  }
}

const startOfDay = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime()

 const dayLabel = (d, now = new Date()) => {
  const days = Math.round((startOfDay(now) - startOfDay(d)) / 86400000)
  if (days === 0) return 'Today'
  if (days === 1) return 'Yesterday'
  return _time.getDateString.call(void 0, d)
}; exports.dayLabel = dayLabel

/* rows: newest first, as the store keeps them. Returns the thread oldest
 * first. */
 const buildThread = (rows, people, now = new Date()) => {
  const items = []
  const byKey = new Map(rows.map(row => [String(row.MessageKey), row]))
  let previous = null
  let previousDay = null

  for (let i = rows.length - 1; i >= 0; i--) {
    const row = rows[i]
    const sentAt = new Date(row.SentTimestamp)
    const day = startOfDay(sentAt)
    if (day !== previousDay) {
      items.push({ kind: 'day', key: `day:${day}`, label: exports.dayLabel.call(void 0, sentAt, now) })
      previousDay = day
      previous = null
    }

    if (row.Type === 'meta') {
      items.push({ kind: 'meta', key: String(row.MessageKey), text: _nullishCoalesce(row.TextContent, () => ( '')) })
      previous = null
      continue
    }

    const sender = senderOf(row)
    const mine = isSet(row.FromPatientKey) && row.FromPatientKey === people.currentPatientKey
    const continues = previous !== null &&
      senderOf(previous.row) === sender &&
      sentAt.getTime() - previous.sentAt.getTime() < RUN_WINDOW_MS
    if (previous && continues) previous.runLast = false

    let senderName = ''
    if (exports.isAutoReply.call(void 0, row)) senderName = AUTO_REPLY_NAME
    else if (!mine) {
      senderName = _nullishCoalesce((isSet(row.FromPatientKey)
        ? _optionalChain([people, 'access', _11 => _11.patients, 'access', _12 => _12[row.FromPatientKey], 'optionalAccess', _13 => _13.Name])
        : _optionalChain([people, 'access', _14 => _14.users, 'access', _15 => _15[String(row.FromUserKey)], 'optionalAccess', _16 => _16.Name])), () => ( ''))
    }

    const item = {
      kind: 'message',
      // A text keeps its key from send to server copy, so its row stays mounted.
      key: String(row.MessageKey),
      row,
      mine,
      senderName,
      sentAt,
      runFirst: !continues,
      runLast: true,
      quote: quoteOf(row, people, byKey),
    }
    items.push(item)
    previous = item
  }

  return items
}; exports.buildThread = buildThread
